module.exports = __webpack_public_path__ + "img/icon_boy.bb646c15.svg";